import { useEffect, useState } from 'react';

export function useIntersectionObserver(
  elementRef: React.RefObject<HTMLDivElement>,
  { threshold = 0, root = null, rootMargin = '0%', freezeOnceVisible = false },
) {
  const [entry, setEntry] = useState<IntersectionObserverEntry | undefined>();

  const frozen = entry?.isIntersecting && freezeOnceVisible;

  const updateEntry: IntersectionObserverCallback = ([e]) => {
    setEntry(e);
  };

  useEffect(() => {
    const node = elementRef?.current;
    const hasIOSupport = !!window.IntersectionObserver;

    if (!hasIOSupport || frozen || !node) return;

    const observerParams = { threshold, root, rootMargin };
    const observer = new IntersectionObserver(updateEntry, observerParams);

    observer.observe(node);

    // eslint-disable-next-line consistent-return
    return () => observer.disconnect();
  }, [elementRef, threshold, root, rootMargin, frozen]);

  return entry;
}
